import loadScript from './loadScript';
import * as cache from './cache';
import { productPage, cartPage } from './pages';
import { isProductPage, isCartPage } from './utils';
import errorHandler from './errorHandler';
import { isDevMode } from './devMode';
export default function app() {
  getPredsAndAddOns(function(response) {
    const options = response.options;
    const addOnsDb = response.addons;

    if (!addOnsDb || (options.disableApp && !isDevMode())) return;

    if (
      isProductPage() &&
      (!options.noproduct || options.noproduct === 'false')
    ) {
      productPage(options, addOnsDb);
    } else if (isCartPage() && options.cart && options.cart !== 'false') {
      cartPage(options, addOnsDb);
    }
  });
}

function getPredsAndAddOns(callBack) {
  if (!isDevMode() && loadFromCache(callBack)) {
    return;
  }

  const shopname = IS_SHOPIFY_ENV
    ? Shopify.shop.split('.myshopify.com')[0]
    : 'studtack';
  const config = {
    apiKey: API_KEY,
    authDomain: AUTH_DOMAIN,
    databaseURL: DATABASE_URL,
    projectId: PROJECT_ID
  };
  loadScript(
    'https://www.gstatic.com/firebasejs/6.6.1/firebase-app.js',
    function() {
      loadScript(
        'https://www.gstatic.com/firebasejs/6.6.1/firebase-database.js',
        function() {
          //Some Apps are really naugthy and have process as a globa var
          //we are just going to rest it
          window.process = undefined;
          const addOnApp = firebase.initializeApp(config, 'addOnApp');
          const root = addOnApp
            .database()
            .ref(shopname)
            .limitToFirst(2);
          root.once('value', function(snapshot) {
            try {
              const rootVal = snapshot.val();
              if (rootVal) {
                cache.set(rootVal.prefs, rootVal.addons);
                callBack({
                  options: rootVal.prefs || getDefaultOpitons(),
                  addons: rootVal.addons
                });
              }
            } catch (err) {
              errorHandler(err);
            }
          });
        }
      );
    }
  );
}

function loadFromCache(callBack) {
  const cached = cache.get();
  if (cached && cached.options && cached.addons) {
    callBack(cached);
    return true;
  }
  return false;
}

function getDefaultOpitons() {
  return {
    addOnType: 'button',
    showDetailsLink: true,
    showPlus: true,
    bold: true,
    showBorder: true,
    textColor: '000000'
  };
}
